import { Component } from '@angular/core';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-discard-case',
  templateUrl: './discard-case.component.html',
  styleUrls: ['./discard-case.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeIconComponent,
    PayeeButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class DiscardCaseComponent {
  constructor() {}
}
